import { toast } from "react-toastify";
//primeReact
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
//components
import Input from "../../../components/input/Input";
//services
import { onSubmitAccessGroup } from "../../../services/Settings/AccessGroup/createAccessGroup";

const ModalCreateAccessGroup = ({ visible, setVisible, loading, refresh }) => {
  const {
    control: controlDescription,
    handleSubmit: handleDescription,
    formState: { errors },
  } = useForm();

  function sendDescription(data) {
    setVisible(false);
    const notification = toast.loading("Aguarde, cadastrando grupo de acesso");
    loading(true);

    onSubmitAccessGroup(data)
      .then(() => {
        toast.update(notification, {
          render: "Grupo de Acesso Adicionado",
          type: "success",
          theme: "colored",
          autoClose: 5000,
          isLoading: false,
        });
        // Chamar refetch para atualizar os dados após a conclusão da requisição
        refresh();
      })
      .catch((error) => {
        toast.update(notification, {
          render: "Ocorreu um erro a cadastrar, tente novamente",
          type: "error",
          theme: "colored",
          autoClose: 5000,
          isLoading: false,
        });
      })
      .finally(() => {
        loading(false);
      });
  }
  return (
    <>
      <Dialog
        header="Cadastrar Grupo de Acesso"
        id="modal_cad"
        className="rounded-4"
        onHide={() => setVisible(false)}
        visible={visible}
        style={{ width: window.innerWidth <= 992 ? "85vw" : "40vw" }}
      >
        <div>
          <p>
            {" "}
            <i className="pi pi-user mr-2"></i> Informações do Grupo
          </p>
        </div>

        <form onSubmit={handleDescription(sendDescription)}>
          <div className="row">
            <div className="col-md-12 mb-4">
              <Input
                id="name"
                className="w-100"
                control={controlDescription}
                name="name"
                label="Descrição"
                errors={errors}
              />
            </div>
            <div className="text-center">
              <Button
                rounded
                label="Cadastrar"
                icon="fa fa-plus"
                type="submit"
                className="p-inputtext-sm m-auto"
              />
            </div>
          </div>
        </form>
      </Dialog>
    </>
  );
};

export default ModalCreateAccessGroup;
